import './Label.css';
export var labelStyle = '_bh277f0-3-5-0';